/**
 * Список всех api сущностей модуля для удобства импортирования в других модулях.
 */
import OrderApi from './OrderApi'
import CartApi from './CartApi'

export const order = new OrderApi('shop/site/order')
export const cart = new CartApi('shop/site/cart')



// WEBPACK FOOTER //
// ./dev-packages/Shop/assets/site/api.js